import { render, staticRenderFns } from "./UserRecentBookings.vue?vue&type=template&id=fda6b44c&"
import script from "./UserRecentBookings.vue?vue&type=script&lang=js&"
export * from "./UserRecentBookings.vue?vue&type=script&lang=js&"
import style0 from "./UserRecentBookings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports